/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type BookingInvoiceApiResourceFinixState = typeof BookingInvoiceApiResourceFinixState[keyof typeof BookingInvoiceApiResourceFinixState] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BookingInvoiceApiResourceFinixState = {
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  CANCELED: 'CANCELED',
  PENDING: 'PENDING',
  UNKNOWN: 'UNKNOWN',
  RETURNED: 'RETURNED',
} as const;
